import { useRequest } from 'ahooks'
import { useState, useEffect } from 'react'
import { Field, Modal, SubmitButton, EyeButton, Typography } from '~components'
import Subtitle from '~components/dumbs/Subtitle'
import Title from '~components/dumbs/Title'
import { useStore, usePathValidation, useNavigate } from '~hooks'
import { Auth } from '~services'
import { string, object } from '~utils/validation'
import { Values } from './interfaces'
import * as Styled from './styled'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import axios, { AxiosError } from 'axios'
import { track } from '@amplitude/analytics-browser'

function PlatePassword() {
  const defaultValues = {
    password: '',
  }
  const schema = object({
    password: string(),
  })
  const { loading, runAsync } = useRequest(Auth.confirmPlate, { manual: true })
  const store = useStore()
  const navigate = useNavigate()
  const [isPasswordVisible, setPasswordVisible] = useState(false)
  const [openModal, setOpenModal] = useState(false)
  const modalButton = {
    onClick: handleClickPrimaryButton,
    text: 'WhatsApp',
    forWhatsApp: true,
  }
  const {
    handleSubmit,
    formState: { errors, isValid, isDirty },
    register,
    setError,
    setFocus,
  } = useForm({
    defaultValues,
    mode: 'onSubmit',
    resolver: yupResolver(schema),
  })

  usePathValidation(['cpf', 'plate'])
  useEffect(() => {
    track('perfil_senha_placa')
  }, [])
  function handleClickPrimaryButton() {
    window.open(
      `https://wa.me/551141181843/?text=Olá! Quero recuperar minha senha da placa ${store.plate.toUpperCase()}. Meu CPF é o ${
        store.cpf
      }. Pode me ajudar?`,
    )
  }
  function handleClickShowPassword() {
    setFocus('password')
    setPasswordVisible((prevState) => !prevState)
  }

  function handleClickForgotPassword() {
    navigate('/cadastrar/confirmar-celular')
  }

  function handleClickNeedHelp() {
    setOpenModal(true)
  }

  function handleClickCloseModal() {
    setOpenModal(false)
  }
  async function onSubmit(values: Values) {
    try {
      const data = await runAsync({
        username: store.cpf,
        password: values.password,
        plate: store.plate,
      })
      localStorage.setItem('token', data.token)
      navigate('/entrar/placa/nova-senha')
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError<{ blocked_until: string }>
        if (axiosError.response.data.blocked_until) {
          store.update({ login: { blockedTime: axiosError.response.data.blocked_until } })
          navigate('/cadastrar/confirmar-celular')
        }
      }
      setError('password', { type: 'manual', message: 'Senha incorreta.' })
    }
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} aria-labelledby="form-password-title">
        <Title id="form-password-title">Que bom que você voltou!</Title>
        <Subtitle>
          Digite a senha da placa{' '}
          <Typography as="b">{store?.plate?.toUpperCase()}</Typography>.
        </Subtitle>
        <Field
          data-testid="password"
          name="password"
          label="Senha"
          type={isPasswordVisible ? 'text' : 'password'}
          icon={
            <EyeButton onClick={handleClickShowPassword} visibility={isPasswordVisible} />
          }
          isValid={isValid}
          register={register}
          error={errors.password}
          key="password"
          maxLength={72}
        />
        <SubmitButton
          width="100%"
          loading={loading}
          key="submit-button"
          disabled={!isDirty}
        >
          Continuar
        </SubmitButton>
        <Styled.LinkButton
          type="button"
          width="100%"
          color="tertiary"
          onClick={handleClickForgotPassword}
        >
          Esqueci a senha
        </Styled.LinkButton>
        <Styled.LinkButton
          type="button"
          width="100%"
          color="subtle"
          onClick={handleClickNeedHelp}
        >
          Preciso de ajuda
        </Styled.LinkButton>
      </form>
      <Modal
        open={openModal}
        onClose={handleClickCloseModal}
        title="Está com dificuldades para acessar a Fretebras?"
        message="Entre em contato que nós vamos te ajudar."
        buttons={{ primary: modalButton }}
      />
    </>
  )
}

export default PlatePassword
